import { useState } from 'react';
import { Bell, X } from 'lucide-react';
import { usePushNotifications } from '../hooks/usePushNotifications';

/**
 * Non-intrusive prompt to request push notification permission.
 * Only shows for logged-in users who haven't granted/denied yet.
 * Dismissable — won't block the experience.
 */
export function PushPermissionPrompt() {
  const { state, isSubscribed, subscribe } = usePushNotifications();
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem('push-prompt-dismissed') === 'true';
  });
  const [isLoading, setIsLoading] = useState(false);

  // Don't show if: unsupported, already granted/subscribed, denied, dismissed, or not logged in
  const token = localStorage.getItem('token');
  if (!token || state !== 'prompt' || isSubscribed || dismissed) {
    return null;
  }

  const handleEnable = async () => {
    setIsLoading(true);
    await subscribe();
    setIsLoading(false);
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('push-prompt-dismissed', 'true');
  };

  return (
    <div className="fixed bottom-4 right-4 z-40 max-w-sm w-full mx-4 sm:mx-0">
      <div className="bg-white border border-gray-200 rounded-xl shadow-lg p-4">
        <div className="flex items-start space-x-3">
          <div className="w-9 h-9 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
            <Bell className="w-4 h-4 text-indigo-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900">¿Activar notificaciones?</p>
            <p className="text-xs text-gray-500 mt-0.5">
              Recibe alertas cuando recibas donaciones o cuando tus aportes sean verificados.
            </p>
            <div className="flex items-center space-x-2 mt-3">
              <button
                onClick={handleEnable}
                disabled={isLoading}
                className="px-3 py-1.5 text-xs font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-colors"
              >
                {isLoading ? 'Activando...' : 'Activar'}
              </button>
              <button
                onClick={handleDismiss}
                className="px-3 py-1.5 text-xs font-medium text-gray-600 hover:text-gray-800 transition-colors"
              >
                Ahora no
              </button>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
